import React from "react";
import { useTranslation } from "react-i18next";
import { ComingSoonCard } from "../../../components/ComingSoonCard";

/** Gift-box icon for the Referral card. */
const GiftIcon: React.FC = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="8" width="18" height="4" rx="1" />
    <path d="M12 8v13M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
    <path d="M12 8S10.5 3 8 3a2.5 2.5 0 0 0 0 5m4 0s1.5-5 4-5a2.5 2.5 0 0 1 0 5" />
  </svg>
);

/**
 * Referral teaser next to the source bar (FE-3): Referral analytics have no data
 * yet (referral = 0/planned). Thin wrapper over the reusable {@link ComingSoonCard}
 * so the same teaser can introduce other upcoming features later.
 */
export const ReferralCard: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ComingSoonCard
      badge={t("dashboard.referral.badge")}
      icon={<GiftIcon />}
      title={t("dashboard.referral.title")}
      body={t("dashboard.referral.body")}
      footerLabel={t("dashboard.referral.footer")}
    />
  );
};
